import "core-js/modules/es.array.filter";
import "core-js/modules/es.parse-int";
export var msaByAlias = function msaByAlias(msas, alias) {
  return (msas || []).filter(function (msa) {
    return msa.alias === alias;
  })[0];
};
export var msaById = function msaById(msas, id) {
  return (msas || []).filter(function (msa) {
    return msa.id === id;
  })[0];
};
export var msaByIdentifier = function msaByIdentifier(msas, identifier) {
  return typeof identifier === 'number' ? msaById(msas, identifier) : msaByAlias(msas, identifier) || msaById(msas, parseInt(identifier, 10));
};